export default __webpack_public_path__ + "static/media/guests.e022c8e7.svg";